'use client'

import { useEffect } from 'react'
import { ScreenChrome } from '@/components/screen-chrome'
import { ErrorState } from '@/components/v/error-state'
import { useI18n } from '@/i18n/context'
import { hapticNotify, hapticTap } from '@/lib/telegram/haptics'

// Route-level error boundary (Next.js App Router). Catches any error thrown
// while rendering — or in an effect of — a page under the root layout, so a
// single broken screen shows a recoverable fallback instead of unmounting
// the whole mini app to a white screen.
//
// This renders INSIDE the root layout, so the QueryClient + I18n providers
// are still mounted and `useI18n` works. Errors originating in the root
// layout itself are caught one level up by `global-error.tsx`.
export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { t } = useI18n()

  useEffect(() => {
    hapticNotify('error')
    // `digest` is Next's server-side error hash; pairing it with the message
    // is what lets us line up a client report against server logs.
    console.error('[app/error]', error.digest ?? '(no digest)', error)
  }, [error])

  return (
    <ScreenChrome enableBack={false}>
      <ErrorState
        variant="generic"
        title={t('errorTitle')}
        body={t('errorBody')}
        actionLabel={t('tryAgain')}
        onAction={() => {
          hapticTap('medium')
          reset()
        }}
      />
    </ScreenChrome>
  )
}
